(function() {
	/*
	 * Signup Button
     *
     * Attributes:
     *  @btnState {String} - current state of the button. Valid values: default, full, selected, locked
     *  @ngStyle {Object} - css rules for the button
     *  @btnDisabledClickable - whether or not a disabled button should be clickable (ex. SUG-16515 calendar view behavior.)
     *
     * Usage: <signup-button btn-state="i.btnState" waitlist-position="i.waitlistPosition" data-ng-click="toggleSlotItem(i)" data-ng-style="{'background-color':theme.buttoncolor, 'color':theme.buttontextcolor}"></signup-button>
	 */
	SUGApp.directive('signupButton', ['profilePicService', function (profilePicService) {
		return {
			restrict: 'E',
			templateUrl: '/view/templates/ngtemplates/signup-button.html',
			scope: {
                btnState: '=?',
                ngStyle: '<',
                btnClasses: '=',
                btnDisabledClickable: '@',
                waitlistPosition: '<?'
			},
			link: function(scope, element, attrs) {

                var stateLabels = {
                    'selected': 'Selected',
                    'full': 'Full',
                    'locked': 'Locked',
                    'default': 'Sign Up',
                    'edit': 'Edit',
                    'waitlist': 'Join Waitlist',
                    'waitlist_disabled': 'Join Waitlist',
                    'waitlisted': '#? on Waitlist',
                };

                // maintains the button state to handle selection / deselection
                const initialButtonState = scope.btnState ?? 'default';

				// this runs first
				function init(){
                    if( !scope.btnState ){ scope.btnState = 'default'; }
				}

                /**
                 * Gets the button label based on the current state
                 */
                scope.getBtnLabel = function(){
                    if( scope.btnState && stateLabels[scope.btnState] ){
                        if (scope.btnState == 'waitlisted') {
                            let label = stateLabels[scope.btnState];
                            label = label.replace("?", scope.waitlistPosition);
                            return label;
                        }
                        else {
                            return stateLabels[scope.btnState];
                        }
                    }else{
                        return stateLabels['default'];
                    }
                };

                /**
                 * Updates the button's state based on the current state
                 */
                scope.updateBtnState = function(){
                    if( scope.btnState === 'default' || scope.btnState === 'waitlist' ){
                        scope.btnState = 'selected';
                    }else if( scope.btnState === 'selected' ){
                        scope.btnState = initialButtonState;
                    }
                };

                /**
                 * Determines if the waitlist class should be applied
                 */
                scope.waitlistButtonClass = function() {
                    return scope.btnState === 'waitlisted'? 'btn-signup-waitlist' : '';
                };

                /*
                 * Generates dynamic styles for the button based on the passed in ng-style object
                 */
                scope.getBtnStyles = function(){
                    return {
                      "background-color": scope.ngStyle["background-color"],
                      color: scope.ngStyle["color"]
                    };
                };

                /**
                 * Determines if the button is disabled based on the current state
                 */
                scope.isDisabled = function(){
                    // need to understand the difference between full versus max limit full in restrictions
                    if (typeof scope.btnDisabledClickable !== 'undefined' && scope.btnDisabledClickable) { return false; }
                    else { 
                        return ((scope.btnState === 'full' && scope.btnState !== 'waitlist') 
                            || scope.btnState === 'waitlisted' 
                            || scope.btnState === 'waitlist_disabled' 
                            || scope.btnState === 'locked'); 
                        }
                };


                // fire init
				init();
            }
        };
    }]);

}());
